export default __webpack_public_path__ + "static/media/Measuring tape-new-gray.b17dcccf.svg";